// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25C7M","col":"styles_col__2JT0j"};